import React from "react";
import {Alert, AlertProps} from "@mui/material";

export default function DPAlert(props: AlertProps) {
  return <Alert {...props} />;
}
